let survey = {
  path: '/survey',
  name: 'survey',
  component: () => import('@/views/survey/index.vue'),
  meta: {
    name: '首页'
  }
}

export default survey
